import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {MessageService} from 'primeng/api';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../cc-base.component';
import {FormFieldGroupConfig} from '../../model/api/form-field-group-config';
import {FormFieldConfig} from "../../model/api/form-field-config";
import {CcFormComponent} from "./form/cc-form.component";
import {takeUntil, timer} from "rxjs";

@Component({
  selector: 'app-cc-form-dialog[formConfig]',
  templateUrl: './cc-form-dialog.component.html',
  styleUrls: ['./cc-form-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CcFormDialogComponent extends CcBaseComponent {

  @Input()
  formConfig: FormFieldGroupConfig[];

  @Input()
  dialogFormVisible: boolean = false;
  @Output()
  dialogFormVisibleChange = new EventEmitter<boolean>();

  @Input()
  dialogFormTitle: String = '';

  @Input()
  formRecord: any;
  @Output()
  formRecordChange = new EventEmitter<any>();

  @Input()
  submitted: boolean = false;

  @Input()
  transPartKey: String;

  @Input()
  fieldName: String;

  @Input()
  submitButtonLabel: String;

  @Input()
  disableSubmitButton: boolean = false;

  @Input()
  cancelButtonLabel: String;

  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onSubmitEvent = new EventEmitter<any>();

  @Input()
  loading: boolean = false;

  @Input()
  loadingProgressValue: number = 100;

  @Input()
  globalErrorMessage: string;

  @Input()
  globalInfoMessage: string;

  @Input()
  dialogClass: string = '';

  recordName: string = '';

  formValid: boolean = false;

  @ViewChild('ccForm')
  ccForm: CcFormComponent;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,) {
    super(cdref, messageService, translateService);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {
    this.initConfigs();
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.initConfigs();
    });
  }

  protected initConfigs() {
    // this.cronField.tabs = this.cronTabs;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private getRecordName() {
    if (this.formRecord) {
      // @ts-ignore
      const name = this.formRecord[this.fieldName];
      if (name) {
        return ' "' + name + '"';
      }
    }
    return '';
  }

  onShow() {
    timer(100)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (document.activeElement as HTMLElement | null)?.blur());
    this.dialogFormVisibleChange.emit(true);
  }

  showDialog(): void {
    this.dialogFormVisible = true;
    this.dialogFormVisibleChange.emit(true);
    this.reloadFieldValueMap();
  }

  closeDialog(): void {
    this.dialogFormVisible = false;
    this.dialogFormVisibleChange.emit(false);
    this.markForCheck();
  }

  submit(): void {
    this.formRecordChange.emit(this.formRecord);
    this.onSubmitEvent.emit();
  }

  isLoading(): boolean {
    return this.loading || this.loadingProgressValue < 100;
  }

  //
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes) {
  //     console.log("-------> changes "+JSON.stringify(changes));
  //   }
  // }

  validateForm(): void {
    if (!this.formRecord) {
      this.formValid = false;
    }
    this.formValid = this.validateFields(this.formConfig, this.formRecord);
  }

  private validateFields(formConfigToValidate: FormFieldGroupConfig[], record: any) {
    let valid: boolean = record;
    if (valid) {
      formConfigToValidate.forEach(grpConfig => {
        if (!grpConfig.hidden || !grpConfig.hidden(record)) {
          grpConfig.fields.forEach(config => {
            if (!config.hidden || !config.hidden(record)) {
              if (config.required && (!config.disabled || !config.disabled(record))
                && (!record[config.field] || (record[config.field] + '').length === 0)
                || (config.validate ? config.validate(record) != '' : false)) {
                valid = false;
                // console.log("-----> not valid " + config.field + " --> " + record[config.field]);
              } else if (valid && (config.type === FormFieldConfig.TYPE.RICHFIELD
                || config.type === FormFieldConfig.TYPE.ADDDELETEFIELD)) {
                if (record[config.field]) {
                  record[config.field].forEach(subRecord => {
                    if (valid)
                      valid = this.validateFields(config.richFieldConfig.fields, subRecord);
                  });
                }
              } else if (valid && (config.type === FormFieldConfig.TYPE.SINGLERICHFIELD)) {
                valid = this.validateFields(config.richFieldConfig.fields, record[config.field]);
              }
            }
          });
        }
      });
    }
    return valid;
  }

  public reloadFieldValueMap(): void {
    setTimeout(() => {
      this.recordName = this.getRecordName();
      if (this.ccForm)
        this.ccForm.reloadFieldValueMap();
      this.markForCheck();
    });
  }

  @HostListener('document:keydown.control.enter', ['$event'])
  submitShortCut(e: KeyboardEvent): void {
    if (!this.dialogFormVisible || this.loading || !this.formValid) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    this.submit();
  }
}
